<app-pageheader [Parent]="this">
  <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Printer Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" type="text" />
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Printer Type">
              <div class="control select">
                <select formControlName="PrinterType">
                  <option [ngValue]="null" disabled>Select a printer type...</option>
                  @for (type of printerTypes; track type) {
                    <option [ngValue]="type.Name">{{type.Name}}</option>
                  }
                </select>
              </div>
            </app-field>
            <app-field Label="Paper Size">
              <div class="control select">
                <select formControlName="PrinterPaperSize">
                  <option [ngValue]="null" disabled>Select a paper size...</option>
                  @for (size of paperSizes; track size) {
                    <option [ngValue]="size.Name">{{size.Name}}</option>
                  }
                </select>
              </div>
            </app-field>
            <app-field Label="Disable formatting" tippy="If the printer isn't printing correctly, disabling formatting can help verify whether or not it is a particular style tag that causes issues.">
              <div class="control">
                <app-toggleswitch formControlName="DisableFormatting"/>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}